import React, { Component } from "react";
import { Input } from "../forms/input";
import { QueryAssistant } from "../home/home";
import Appbar from "./appbar";
import DemoCarousel from "./carsouel";
import MenuItem from "@material-ui/core/MenuItem";
import CustomizedSelect from "../home/transactions/customizedSelect";
import IntegrationReactSelect from "../forms/autoCompleteInput";
import Signbutton from "../forms/button";
import copy from "copy-to-clipboard";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {
  EmailShareButton,
  WhatsappIcon,
  EmailIcon,
  WhatsappShareButton,
} from "react-share";
import {
  GET_CATEGORY_LIST,
  GET_CATEGORY_LIST_SUCCESS,
  GET_CATEGORY_LIST_FAILED,
  REGULAR,
  GET_SCHEME_LIST,
  GET_SCHEME_LIST_SUCCESS,
  GET_SCHEME_LIST_FAILED,
} from "../../store/types";
import { validateSubBroker } from "../../store/actions";
import { EuinValidation } from "../../store/actions/generatearn";
import { generateUrl, validateEuin } from "../../store/actions/generatearn";
import { getNewPurchaseFundList } from "../../store/actions/investors";

import { connect } from "react-redux";
import CustomLoader from "../forms/Loader";
class GenerateARNLink extends Component {
  constructor(props) {
    super(props);
    this.state = {
      radioValue: { value: "YES" },
      brokerCode: { value: "" },
      euinCode: { value: "", disabled: true },
      subBrokerCode: { value: "" },
      categories: [],
      schemes: [],
      category: { value: "" },
      scheme: { value: "" },
      link: {
        value: "",
      },
      shareopen: false,
      euinList: [],
      isLoading: false,
    };
  }

  async componentDidMount() {
    const params = {
      opt: "AT",
      plntype: REGULAR,
      fund: "189",
    };
    const types = [
      GET_CATEGORY_LIST,
      GET_CATEGORY_LIST_SUCCESS,
      GET_CATEGORY_LIST_FAILED,
    ];
    const response = await this.props.getNewPurchaseFundList(params, types);

    this.setState({
      categories: response.Dtinformation || [],
    });
  }
  validateEuinNo = async () => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();

    today = mm + "/" + dd + "/" + yyyy;
    const response = await this.props.validateEuin({
      BroCode: "ARN-" + this.state.brokerCode.value,
      Euin: this.state.euinCode.value.value,
      OutFlag: "Y",
      TrDate: today,
    });
    const data = response.Dtinformation[0];
    if (data.Msg !== "Valid EUIN" && !!this.state.euinCode.value) {
      this.setState({
        euinCode: {
          value: this.state.euinCode.value,
          isError: true,
          errorMessage: data.Msg,
        },
      });
    }
  };
  changeValue = (label) => (event) => {
    this.setState({
      [label]: { value: event.target.value },
    });
  };

  handleCategoryChange = (label) => async (event) => {
    this.setState({
      [label]: { value: event.target.value },
      link: { value: "" },
      scheme: { value: "" },
    });
    if (!!event.target.value) {
      let params = { plntype: REGULAR };
      params = {
        ...params,
        opt: "S",
        schemetype: event.target.value,
        fund: "189",
      };
      const types = [
        GET_SCHEME_LIST,
        GET_SCHEME_LIST_SUCCESS,
        GET_SCHEME_LIST_FAILED,
      ];
      const response = await this.props.getNewPurchaseFundList(params, types);

      this.setState({
        schemes: !!response.Dtinformation ? response.Dtinformation : [],
      });
    } else {
      this.setState({
        [label]: { value: event.target.value },
        scheme: { value: "" },
      });
    }
  };

  changeScheme = (value) => {
    this.setState({
      scheme: { value: value, isError: false, errorMessage: "" },
      link: { value: "" },
    });
  };
  Euincheck = async () => {
    const params = {
      fund: "189",
      euin: `E${this.state.euinCode.value}`,
      arn: `ARN-${this.state.brokerCode.value}`,
    };
    const response = await this.props.EuinValidation(params);
    if (!response == true) {
      this.setState({
        euinCode: {
          value: "",
        },
        link: { value: "" },
      });
    }
  };

  Euinchange = (e) => {
    this.setState({ euinCode: { value: e.target.value, disabled: false } });
  };

  submit = async () => {
    const {
      categories,
      link,
      schemes,
      euinCode,
      subBrokerCode,
      shareopen,
      euinList,
      isLoading,
      ...others
    } = this.state;
    const keys = Object.keys(others);

    if (this.state.subBrokerCode.value === this.state.brokerCode.value) {
      this.setState({
        subBrokerCode: {
          value: "",
          isError: true,
          errorMessage: "Sub Broker Code should not be same as Broker Code",
        },
      });
      return;
    }
    const findError = keys.every((key) => !!others[key].value);
    if (!findError) {
      keys.forEach((key) => {
        !others[key].value &&
          this.setState({
            [key]: {
              ...others[key],
              isError: true,
              errorMessage: `${
                key === "category"
                  ? "Category"
                  : key === "scheme"
                  ? "Scheme"
                  : key === "brokerCode"
                  ? "Broker Code"
                  : key
              } is mandatory`,
            },
          });
      });
      const firstErroredKey = keys.find((key) => !others[key].value);
      switch (firstErroredKey) {
        case "brokerCode": {
          this.brokerCodeField.focus();
          break;
        }
        case "category": {
          this.categoryField.focus();
          break;
        }
        case "scheme": {
          this.schemeField.focus();
          break;
        }
        default:
          break;
      }
    } else if (
      this.state.radioValue.value === "NO" &&
      !this.state.euinCode.value
    ) {
      this.setState({
        euinCode: {
          value: "",
          isError: true,
          errorMessage: "EUIN Code is Mandatory",
        },
      });
      // this.euinCodeField.focus();
      return;
    } else {
      const schemeDetails = this.state.scheme.value.value.split("~");
      const opt = schemeDetails[3];
      const plan = schemeDetails[2];
      const params = {
        scheme: this.state.scheme.value.value,
        subbroker: !!this.state.subBrokerCode.value
          ? "ARN-" + this.state.subBrokerCode.value
          : "",
        agentid: !!this.state.brokerCode.value
          ? "ARN-" + this.state.brokerCode.value
          : "",
        plan,
        opt,
        ...(!!this.state.euinCode.value && {
          euin: `E${this.state.euinCode.value}`,
          EUINFlag: "NO",
        }),
        ...(!this.state.euinCode.value && {
          EUINFlag: "YES",
        }),
      };
      const response = await this.props.generateUrl(params);
      const data = !!response.Dtinformation[0] ? response.Dtinformation[0] : {};
      this.setState({
        link: { value: !!data.Link ? data.Link : data.Message },
      });
    }
  };
  validateSubBrokerCode = () => {
    if (this.state.subBrokerCode.value === this.state.brokerCode.value) {
      this.setState({
        subBrokerCode: {
          value: "",
          isError: true,
          errorMessage: "Sub Broker Code should not be same as Broker Code",
        },
      });
    }
  };
  copyLinktoCilpboard = () => {
    if (!!this.state.link.value) {
      copy(this.state.link.value);
      alert("Link copied successfully");
    }
  };
  changeEuin = () => (event) => {
    if (event.target.value === "YES") {
      this.setState({
        euinCode: { value: "", disabled: true },
        radioValue: { value: event.target.value },
      });
    } else {
      this.setState({
        euinCode: { value: "", disabled: false },
        radioValue: { value: event.target.value },
      });
    }
  };
  // fetchEuinList = () => async () => {
  //   try {
  //     this.setState({ isLoading: true });
  //     const params = {
  //       Fund: "189",
  //       SubAgentCd: !!this.state.subBrokerCode.value
  //         ? `ARN-${this.state.subBrokerCode.value}`
  //         : "-",
  //       AgentCd: `ARN-${this.state.brokerCode.value}`,
  //     };
  //     const response = await this.props.validateSubBroker(params);
  //     const { DtData } = response;
  //     this.setState({
  //       euinList: DtData,
  //     });
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     this.setState({ isLoading: false });
  //   }
  // };
  render() {
    const {
      brokerCode,
      euinCode,
      subBrokerCode,
      category,
      categories,
      scheme,
      schemes,
      link,
      radioValue,
    } = this.state;

    return (
      <div className="login-container">
        {/* <QueryAssistant /> */}
        <Appbar />
        <div className="login-without-appbar">
          <CustomLoader display={this.state.isLoading} />
          <DemoCarousel />
          <div className="login-right-div" style={{ overflow: "scroll" }}>
            <div>
              <div className="login-title">Scheme ARN Link</div>
              <div className="input-margin">
                <Input
                  maxLength={50}
                  name="Broker Code"
                  value={brokerCode.value}
                  onChange={this.changeValue("brokerCode")}
                  onKeyDown={(evt) =>
                    (evt.key === "e" || evt.key === "." || evt.key === "-") &&
                    evt.preventDefault()
                  }
                  type="number"
                  isShowError={brokerCode.isError}
                  errorMessage={brokerCode.errorMessage}
                  inputref={(ele) => (this.brokerCodeField = ele)}
                  // onBlur={this.fetchEuinList()}
                />
              </div>
              <div className="input-margin">
                <Input
                  maxLength={50}
                  name="Sub Broker Code"
                  value={subBrokerCode.value}
                  onChange={this.changeValue("subBrokerCode")}
                  onKeyDown={(evt) =>
                    (evt.key === "e" || evt.key === "." || evt.key === "-") &&
                    evt.preventDefault()
                  }
                  onBlur={this.validateSubBrokerCode}
                  type="number"
                  isShowError={subBrokerCode.isError}
                  errorMessage={subBrokerCode.errorMessage}
                  inputref={(ele) => (this.subBrokerCodeField = ele)}
                />
              </div>
              <div className="input-field-container">
                <div className="input-name">EUIN Declaration</div>
                <div className="euin-text">
                  Please Confirm If Intended Transaction is an Execution Only
                  Transaction or is under Advise to you
                </div>
                <FormControl component="fieldset">
                  <RadioGroup
                    aria-label="Search"
                    name="search"
                    value={radioValue.value}
                    style={{ flexDirection: "row" }}
                    onChange={this.changeEuin("radioValue")}
                  >
                    <div className="investor-radio-button">
                      <FormControlLabel
                        value="YES"
                        control={
                          <Radio
                            className="investor-search-radio"
                            style={{ color: "#005DAC" }}
                          />
                        }
                        className="investor-formcontrol-label"
                        style={{ margin: 0 }}
                      />
                      <div className="investor-form-label">YES</div>
                    </div>
                    <div className="investor-radio-button">
                      <FormControlLabel
                        value="NO"
                        control={
                          <Radio
                            className="investor-search-radio"
                            style={{ color: "#005DAC" }}
                          />
                        }
                        className="investor-formcontrol-label"
                        style={{ margin: 0 }}
                      />
                      <div className="investor-form-label">NO</div>
                    </div>
                  </RadioGroup>
                </FormControl>
                {radioValue.value === "NO" && (
                  <div className="input-margin">
                    {/* <IntegrationReactSelect
                      suggestions={this.state.euinList.map((item) => ({
                        value: item.abm_name,
                        label: item.abm_agent,
                      }))}
                      errorMessage={this.state.euinCode.errorMessage}
                      value={euinCode.value}
                      placeholder="Select EUIN"
                      handleChange={(value) =>
                        this.setState({ euinCode: { value } })
                      }
                      inputRef={(ele) => (this.euinField = ele)}
                      isError={euinCode.isError}
                    /> */}
                    <Input
                      maxLength={50}
                      name="EUIN No*"
                      value={this.state.euinCode.value}
                      onChange={this.Euinchange}
                      onBlur={this.Euincheck}
                      type="number"
                      errorMessage={euinCode.errorMessage}
                      isShowError={euinCode.isError}
                    />
                  </div>
                )}
              </div>
              <div className="input-margin">
                <CustomizedSelect
                  name="Category"
                  borderColor="#a6a6a6"
                  handleChange={this.handleCategoryChange("category")}
                  value={category.value}
                  placeholder="Select Category"
                  inputRef={(ele) => (this.categoryField = ele)}
                  isError={category.isError}
                  errorMessage={category.errorMessage}
                >
                  {categories.map((item, index) => (
                    <MenuItem value={item.fm_subcategory} key={index}>
                      {item.fm_subcategory}
                    </MenuItem>
                  ))}
                </CustomizedSelect>
              </div>
              <div className="input-margin">
                <div className="input-name input-integrated-label">Scheme</div>
                <IntegrationReactSelect
                  suggestions={schemes.map((item) => ({
                    label: item.Scheme_Desc,
                    value: item.Scheme_Plan,
                  }))}
                  value={scheme.value}
                  placeholder="Select Scheme"
                  handleChange={this.changeScheme}
                  disabled={!category.value}
                  inputRef={(ele) => (this.schemeField = ele)}
                  isError={scheme.isError}
                  errorMessage={scheme.errorMessage}
                />
              </div>
              <Signbutton buttontitle="SUBMIT" onClick={this.submit} />{" "}
              <Input
                maxLength={50}
                name="Link"
                value={!!link.value ? link.value : ""}
                copyimage={"/images/dit_copy.svg"}
                shareimage={"/images/dit_share.svg"}
                copyOnclick={() => {
                  copy(this.state.link.value);
                  alert("Link Copied");
                }}
                shareOnclick={() =>
                  this.setState({
                    shareopen: !this.state.shareopen,
                  })
                }
              />
              <br />
              {this.state.shareopen && (
                <div style={{ float: "right", display: "flex" }}>
                  <div style={{ marginTop: 3 }}>
                    <WhatsappShareButton
                      url={this.state.link.value}
                      quote={"Checkout the Distributor Link"}
                    >
                      <WhatsappIcon size={32} round={true} />
                    </WhatsappShareButton>
                  </div>
                  <div style={{ marginTop: 3 }}>
                    <EmailShareButton
                      subject={`Distributor Link`}
                      body={`Check out Distributor Link : ${this.state.link.value}`}
                    >
                      <EmailIcon size={32} round={true} />
                    </EmailShareButton>
                  </div>
                </div>
              )}
              <span
                className="login-no-account-span mouse-pointer"
                onClick={() => this.props.history.push("/login")}
              >
                Back to Login Page
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null, {
  generateUrl,
  getNewPurchaseFundList,
  validateEuin,
  validateSubBroker,
  EuinValidation,
})(GenerateARNLink);
